<div *ngIf="reservationInfo && checkReservationPageVisibility()">
    <div *ngIf="!ticketReservation.code && !showTerms">
        <div class="row mb-2">
            <div class="col-lg-4 none-right-padding rightborder">
                <div class="right-padding">
                    <app-reservation-category-select [categories]="reservationInfo.categories" (categoryChanged)="resetTimer()">
                    </app-reservation-category-select>
                </div>
                <hr>
                <div class="right-padding">
                    <app-reservation-questionaire [questions]="reservationInfo.questions"
                        (formInvalid)="checkForm($event)">
                    </app-reservation-questionaire>
                </div>
            </div>
            <div class="col-lg-4">
                <app-reservation-calendar [reservationsEndTime]="reservationInfo.configuration.reservationsEndTime"
                    [categoryMonthCapacity]="reservationInfo.categoryMonthCapacity">
                </app-reservation-calendar>
            </div>
            <div class="col-lg-4">
                <app-reservation-times [availableTimes]="reservationInfo.availableTimes" [setZeroTimer]="triggerResetTimer"></app-reservation-times>
            </div>
        </div>
        <mat-checkbox color="primary" [(ngModel)]="termsChecked">
            {{ 'accept' | translate }}
        </mat-checkbox>
        <span class="terms" (click)="showTerms = !showTerms">{{ reservationInfo.configuration.termsTitle }}</span>
        <app-submit-reservation [formInvalid]="formInvalid" [categoryName]="selectedCategoryName"
            [termsChecked]="termsChecked" [reservationInfo]="reservationInfo">
        </app-submit-reservation>
    </div>
    <div *ngIf="showTerms">
        <button (click)="showTerms = !showTerms" class="btn btn-primary">{{ 'back' | translate }}</button>
        <div [innerHTML]="reservationInfo.configuration.terms"></div>
        <button (click)="showTerms = !showTerms" class="btn btn-primary">{{ 'back' | translate }}</button>
    </div>
    <app-reservation-confirm *ngIf="ticketReservation.code" [ticketReservation]="ticketReservation"
        [categoryName]="selectedCategoryName" [showConfirmation]="showConfirmation"
        [confirmationTime]="reservationInfo.configuration.removeUnconfirmedMins">
    </app-reservation-confirm>
</div>
<div *ngIf="reservationInfo && !checkReservationPageVisibility()">
    {{ 'reservation-page-is-active' | translate }} {{ reservationInfo.configuration.startHour }} {{ 'to' | translate }}
    {{ reservationInfo.configuration.endHour }}
</div>
<div *ngIf="!reservationInfo">
    <mat-progress-spinner style="margin: auto;" color="primary" mode="indeterminate">
    </mat-progress-spinner>
</div>